export default __webpack_public_path__ + "app/assets/intestazione_city_cropped-55ed87d7.png";